export const imgUrl = import.meta.env.VITE_APP_IMAGE_URL;
export const url = import.meta.env.VITE_APP_BASE_URL;
// export const url = 'http://localhost:5000';
export const editorUrl = import.meta.env.VITE_APP_ADSIGN_EDITOR_URL;
